/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    strokeColor?: keyof typeof theme.colors;
    size?: 'large' | 'small';
};

export default function UploadToCloudIcon({
    strokeColor,
    size,
    ...props
}: Props) {
    const theme = useTheme();

    if (size === 'small') {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                {...props}
                role="img"
            >
                <path
                    stroke={strokeColor ? theme.colors[strokeColor] : '#fff'}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M13.333 13.167 10 10l-3.333 3.167M10 10v7.125"
                />
                <path
                    stroke={strokeColor ? theme.colors[strokeColor] : '#fff'}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M16.992 15.057a4.041 4.041 0 0 0 1.825-1.893c.37-.806.447-1.707.218-2.559a3.948 3.948 0 0 0-1.48-2.148A4.31 4.31 0 0 0 15 7.623h-1.05a6.23 6.23 0 0 0-1.375-2.517 6.652 6.652 0 0 0-2.393-1.694 6.973 6.973 0 0 0-5.814.203 6.58 6.58 0 0 0-2.256 1.858A6.174 6.174 0 0 0 .936 8.079c-.18.942-.132 1.91.139 2.832.27.922.758 1.774 1.425 2.491"
                />
                <path
                    stroke={strokeColor ? theme.colors[strokeColor] : '#fff'}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M13.333 13.167 10 10l-3.333 3.167"
                />
            </svg>
        );
    }

    return (
        <svg
            width="84"
            height="84"
            viewBox="0 0 84 84"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            role="img"
        >
            <path
                d="M56 56 42 42 28 56"
                stroke={strokeColor ? theme.colors[strokeColor] : '#fff'}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M42 42v31.5"
                stroke={strokeColor ? theme.colors[strokeColor] : '#fff'}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M71.365 64.364A17.5 17.5 0 0 0 63 31.5h-4.41A28 28 0 1 0 10.5 57.05"
                stroke={strokeColor ? theme.colors[strokeColor] : '#fff'}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M56 56 42 42 28 56"
                stroke={strokeColor ? theme.colors[strokeColor] : '#fff'}
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
